import { render, staticRenderFns } from "./UserPasswordCard.vue?vue&type=template&id=ad90c8b8&"
import script from "./UserPasswordCard.vue?vue&type=script&lang=js&"
export * from "./UserPasswordCard.vue?vue&type=script&lang=js&"
import style0 from "./UserPasswordCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports